import { observer } from "mobx-react";
import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

import ServicesSection from "./components/ServicesSection/ServicesSection";
import ReviewsSection from "./components/ReviewsSection/ReviewsSection";
import ReferralSection from "./components/ReferralSection/ReferralSection";
import PerformersSection from "./components/PerformersSection/PerformersSection";
import AdvantagesSection from "./components/AdvantagesSection/AdvantagesSection";
import ArticlesSection from "./components/ArticlesSection/ArticlesSection";
import Button from "components/UI/Button/Button";

import AppStore from "AppStore";

import { CAROUSEL_PROJECT_SLIDES } from "./carouselData";
import { useMatchMedia } from "utils/hooks/use-match-media";
import { COUNT_COMPLETED_TASKS, COUNT_EXCHANGE_USAGE, COUNT_PERFORMERS_HUMANS } from "utils/helpers";

import BgImg from "assets/images/main/main-bg.webp";
import performers from "assets/images/main/performers.webp";

import "./Main.scss";

const Main = observer(({ sponsorId }) => {
  const { isMobile } = useMatchMedia();
  const selectedMarket = useRef(null);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

 const scrollToSelectedMarket = () => {
    if (selectedMarket.current) {
      const top = selectedMarket.current.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <main className="main">
      <Helmet>
        <title>Биржа заданий и ПФ экспериментов — Boostclick.ru</title>
        <meta
          name="description"
          content="Сервис для накрутки ПФ ЛЮДИ: лайки, подписки, отзывы на досках объявлений, маркетплейсах и поисковых системах от реальных пользователей."
        />
        <meta name="robots" content={sponsorId ? "noindex" : "all"} />
        <link
          rel="canonical"
          href={window.location.origin + window.location.pathname}
        />
      </Helmet>

      <section className="main__intro">
        <div className="main__intro-container">
          <div>
            <h1 className="main__intro-container-title">
              Биржа заданий и ПФ экспериментов с реальными исполнителями
            </h1>
            <p className="main__intro-container-text">
              Вы размещаете сценарий, сторонние исполнители выполняют задания взаимодействуют с интерфейсом, делятся мнением, оценивают путь пользователя.
              <br />
              Все фиксируется через отчет.
            </p>
            <div className="main__intro-counts">
              <div>
                <p className="main__intro-counts-title">{COUNT_EXCHANGE_USAGE.toLocaleString()}</p>
                <p className="main__intro-counts-text">Пользователей</p>
              </div>
              <div>
                <p className="main__intro-counts-title">{COUNT_PERFORMERS_HUMANS.toLocaleString()}</p>
                <p className="main__intro-counts-text">Исполнителей</p>
              </div>
              <div>
                <p className="main__intro-counts-title">{COUNT_COMPLETED_TASKS.toLocaleString()}+</p>
                <p className="main__intro-counts-text">Выполнено задач</p>
              </div>
            </div>
          </div>

          <div className="main__intro-performers">
            <Button className="main__button-link" title="Попробовать от 1.5 ₽ / действие" onClick={scrollToSelectedMarket} />
            <img className="main__intro-performers-img" src={performers} alt="Исполнители биржи Boostclick" />
          </div>
        </div>

        <img className="main__intro-bg" src={BgImg} alt="" />
      </section>

      <div className="main__container" ref={selectedMarket}>
        <ServicesSection store={AppStore} isMobile={isMobile} />
        <ArticlesSection isMobile={isMobile} />
        <AdvantagesSection slides={CAROUSEL_PROJECT_SLIDES} isMobile={isMobile} />
        <ReviewsSection isMobile={isMobile} />
        <ReferralSection store={AppStore} isMobile={isMobile} />
        <PerformersSection isMobile={isMobile} />
      </div>
    </main>
  );
});

export default Main;
